import { nanoid } from 'nanoid';

const init = ({ pieces, setWorkers, serverCall }) => {
  let newId = nanoid();
  let timer = null;

  const checkStatus = async () => {
    try {
      let res = await serverCall({ method: 'GET', url: `/services/cc-thumbs/status/${pieces.jobId}`, eamsAuth0: true });

      if(res.status !== 200) {
        clearInterval(timer);
        alert('Error checking conversion status. Contact support.');
        return;
      }

      let job = res.data;

      setWorkers((prev) => {
        const updatedWorkers = {...prev};
        updatedWorkers[newId].data = { status: job.status };
        return updatedWorkers;
      });

      if(job.status === 'error') {
        clearInterval(timer);
        alert('Error generating thumbnail. Contact support.');
        return;
      }

      if(job.status === 'finished') {
        clearInterval(timer);
        let tasks = job.tasks;
        let thumb = tasks.find(x => x.name === 'export-my-thumbnail');
        let converted = tasks.find(x => x.name === 'export-images');
        let thumbnail = thumb.result.files[0];
        let value = pieces.value;

        let update = {
          id: value.id,
          appId: value.appId,
          thumbnail: thumbnail.filename,
          raster: converted?.result?.files
        }

        await serverCall({ method: 'PATCH', data: update, url: `/system/files/log/${value.appId}`, eamsAuth0: true });
        pieces.setFilesLog((prev) => {
          let arr = [...prev];
          let idx = arr.findIndex(x => x.id === value.id);
          arr[idx].thumbnail = thumbnail.filename;
          return arr;
        });
      }
    } catch(err) {
      console.log(err);
    }
  };

  checkStatus();
  timer = setInterval(checkStatus, 2000);

  setWorkers((prev) => ({ ...prev,
    [newId]: {
      worker: { terminate: () => clearInterval(timer) },
      type: 'thumbnails',
      name: pieces.name,
      data: { status: 'starting', progress: 0 }
    }
  }));
}

export default init;
